/** Open outline forms, kept across a grid refresh in this visit. */
const drafts = new Map();

export function readPlotTrackDraft(key) {
  if (!key) return null;
  return drafts.get(String(key)) || null;
}

export function writePlotTrackDraft(key, value) {
  if (!key) return;
  drafts.set(String(key), value);
}

export function clearPlotTrackDraft(key) {
  if (!key) return;
  drafts.delete(String(key));
}

export function clearPlotTrackDrafts() {
  drafts.clear();
}
